import React, { useCallback } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Flex, Grid, GridItem } from "@domestika-dev/prudencio/dist/atoms/Layout";
import { ChevronDown, ChevronUp } from "@domestika-dev/prudencio/dist/atoms/Icons";
import { Text } from "@domestika-dev/prudencio/dist/atoms/Typography";
import CollapsableCard from "../../../../common/CollapsableCard";

const getQuestionKey = (index) => `live_sessions.faq.faq_${index}.q`;

const getAnswerKey = (index) => `live_sessions.faq.faq_${index}.a`;

export const FAQ = () => {
  const intl = useIntl();

  const getCopies = useCallback(() =>
    Array(10)
      .fill()
      .map((_, index) => ({
        title: intl.formatMessage({ id: getQuestionKey(index + 1) }),
        body: intl.formatMessage({ id: getAnswerKey(index + 1) }),
      }))
  );

  const getFAQContent = ({ title, body, rowNumber }) => (
    <GridItem
      gridRow={rowNumber}
      gridColumn="1 / span 8"
      borderBottom="1px solid"
      borderColor="durian"
    >
      <Flex borderBottom="1px solid" borderColor="durian">
        <CollapsableCard
          headlineText={title}
          headlineBackgroundColor="coco"
          paddingX={0}
          marginBottom={0}
          focusOnClick={false}
          closedIcon={() => <ChevronDown />}
          openedIcon={() => <ChevronUp />}
        >
          <Flex paddingTop={5}>
            <Text size="tiny" textAlign="left" as="p">
              {body}
            </Text>
          </Flex>
        </CollapsableCard>
      </Flex>
    </GridItem>
  );

  return (
    <Flex paddingY={8} marginBottom={6} borderTop="1px solid" borderColor="durian">
      <Grid gridRowGap={4}>
        <GridItem gridRow={1} gridColumn="1 / span 8">
          <Text size="medium" fontWeight="medium" as="h2" textAlign="left">
            <FormattedMessage id="teacher_admin.shared.faqs" />
          </Text>
        </GridItem>
        <GridItem gridRow={2} gridColumn="1 / span 8">
          <Grid>
            {getCopies().map(({ title, body }, index) =>
              getFAQContent({ title, body, rowNumber: index + 1 })
            )}
          </Grid>
        </GridItem>
      </Grid>
    </Flex>
  );
};

export default FAQ;
